import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.map')) {
let map = '.map'


  var masterTl = gsap.timeline()

  var stripes = Array.prototype.slice.call(document.querySelectorAll(".strichblock path")).reverse();
  var stripesTl = gsap.timeline()
  stripesTl.from(stripes, {scale: 0, ease: "power2.out", stagger: 0.02}, '=-.01');

  var lines = Array.prototype.slice.call(document.querySelectorAll('.linienblock path')).reverse();
  var linesTl = gsap.timeline()
  linesTl.from(lines, {scale: 0, ease: "power2.out", stagger: 0.1}, '=-.25')

  var circles = Array.prototype.slice.call(document.querySelectorAll('.punktblock path')).reverse();
  var circleTl = gsap.timeline()
  circleTl.from(circles, {scale: 0, ease: "power2.out", stagger: 0.05}, '=-.05')

  let cities = '.city'
  var cityTl = gsap.timeline()
  cityTl.from(cities, {scale: 0, ease: "power2.out", stagger: 0.25}, '=-.5') 

  let trees = '.tree > *'
  var treeTl = gsap.timeline()
  treeTl.from(trees, {scale: 0, transformOrigin: 'bottom', ease: "back.out", stagger: 0.25}, '=-.25')

  let animals = '.animal'
  var animalTl = gsap.timeline()
  animalTl.from(animals{scale: 0, transformOrigin: 'bottom', ease: "back.out", stagger: 0.25})


  masterTl
    .add(stripesTl, "<")
    .add(circleTl, "<")
    .add(linesTl, "<")
    .add(treeTl,  "1")
    .add(animalTl, "<")
    .add(cityTl,  "<");
    
    
// Descriptions

ScrollTrigger.matchMedia({
  "(min-width: 700px)": function() {

  let mapDescriptionsLeft = '.map__desc--1, .map__desc--2'
  let mapDescriptionsRight = '.map__desc--3'
  gsap.utils.toArray(mapDescriptionsLeft).forEach((desc) => {
    gsap.from(desc, 2 {
      x: -200,
      scrollTrigger: {
        trigger: desc,
        // scrub: true,
      }
    });
  })

  gsap.utils.toArray(mapDescriptionsRight).forEach((desc) => {
    gsap.from(desc, 2 {
      x: 200,
      scrollTrigger: {
        trigger: desc,
        // scrub: true,
      }
    });
  })

}})

}

